module.exports = __webpack_public_path__ + "img/sec2.afd6185.svg";